import React from "react";
import { FileSpreadsheet } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import QuoteForm from "@/components/QuoteForm";

export default function QuotationDialog({ lead, open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="quotation-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileSpreadsheet className="h-5 w-5 text-rose-600" /> Quotation
          </DialogTitle>
          <DialogDescription>Build a rate quotation for this customer, preview it and download the PDF.</DialogDescription>
        </DialogHeader>
        {open && <QuoteForm lead={lead} onClose={() => onOpenChange(false)} />}
      </DialogContent>
    </Dialog>
  );
}
